import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import CannedHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/canned-response'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'canned_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'canned_list',
          meta: {
            featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
            // As permissões de conversa acima já estavam declaradas, mas nunca
            // eram consultadas: sem `customRoleGated`, o papel-base `agent` que
            // o AccountUser entrega junto com a Função Personalizada casa
            // primeiro e libera a tela para qualquer role — inclusive uma só
            // com `report_manage`. Ligar o gate faz a lista acima passar a
            // valer para quem TEM role, e mantém intacto quem não tem.
            customRoleGated: true,
          },
          component: CannedHome,
        },
      ],
    },
  ],
};
